// extracted by mini-css-extract-plugin
export default {"ownerInfo":"SharePrivacy_ownerInfo__MkxmL","info":"SharePrivacy_info__SY6eM","avatar":"SharePrivacy_avatar__r4YcG","badge":"SharePrivacy_badge__Ae8Ne"};